import React from 'react';

type IconProps = {
    width?: number;
    height?: number;
    color?: string;
};

const IconArrowDown: React.FC<IconProps> = ({ width = 12, height = 12, color = '#303030' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 12 12"
            fill="none"
        >
            <path
                d="M10.6 2.11719L6 6.71719L1.4 2.11719L0 3.51719L6 9.51719L12 3.51719L10.6 2.11719Z"
                fill={color}
            />
        </svg>
    );
};

export default IconArrowDown;
